import { useState, useCallback } from "react";
import { useSnackbar } from "notistack";
import { backendGet } from "@accredo/fe-shared/services/dataService.js";

/**
 * State and loader for the BookingExportInfoModal.
 */
export function useBookingExportInfo() {
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [bookingExport, setBookingExport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const openBookingExport = useCallback(
    async (bookingExportId) => {
      setOpen(true);
      setIsLoading(true);
      await backendGet(`data/bookingexports/${bookingExportId}`, {
        label: "Buchungsexport",
        enqueueSnackbar,
        options: {
          params: {
            include: [
              "payments",
              "bookings",
              "schaden",
              "created_by",
              "finished_by",
            ],
          },
        },
        setResult: (res) => setBookingExport(res.data),
      });
      setIsLoading(false);
    },
    [enqueueSnackbar]
  );

  return {
    open,
    close: () => setOpen(false),
    bookingExport,
    isLoading,
    openBookingExport,
  };
}
